import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, MessageSquare, ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** Admin → Onboarding Insights teaser (tab in Admin page) */
export default function AdminOnboardingInsightsTab() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/onboarding/insights");
        setStats(data);
      } catch {
        /* access denied handled by parent */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="grid place-items-center py-10">
        <Loader2 className="w-5 h-5 animate-spin text-emerald-400" />
      </div>
    );
  }

  const total = stats?.total_feedback || 0;
  const byStep = stats?.by_step || {};
  const latest = stats?.latest_plan;

  return (
    <div className="space-y-4" data-testid="admin-insights-tab">
      <div className="bg-gradient-to-br from-emerald-500 to-emerald-800 rounded-3xl p-6 text-white">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-4 h-4 text-emerald-200" />
          <p className="text-[10px] font-bold uppercase tracking-widest text-emerald-200">
            Auto-amélioration continue
          </p>
        </div>
        <h3 className="font-display text-2xl font-black leading-tight">
          Prosperr apprend de chaque feedback utilisateur
        </h3>
        <p className="text-sm text-white/70 mt-2 leading-relaxed">
          Chaque étape de l'onboarding collecte le ressenti des utilisateurs. Prosperr analyse ces retours et propose des améliorations concrètes à appliquer.
        </p>
        <Link to="/admin/onboarding/insights">
          <button
            className="mt-4 bg-[var(--surface)] text-[var(--text)] rounded-full px-5 py-2.5 text-sm font-bold active:scale-[0.99] transition-transform flex items-center gap-2"
            data-testid="open-insights-btn"
          >
            Ouvrir les insights
            <ArrowRight className="w-4 h-4" />
          </button>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-[var(--surface)] border border-emerald-500/30 rounded-xl p-4">
          <div className="flex items-center gap-2 mb-1.5">
            <MessageSquare className="w-3.5 h-3.5 text-emerald-400" />
            <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Retours</p>
          </div>
          <p className="font-display text-2xl font-black">{total}</p>
        </div>
        <div className="bg-[var(--surface)] border border-emerald-500/30 rounded-xl p-4">
          <div className="flex items-center gap-2 mb-1.5">
            <Sparkles className="w-3.5 h-3.5 text-emerald-400" />
            <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Plan IA</p>
          </div>
          <p className="text-sm font-bold text-[var(--text)]">
            {latest ? "À jour" : "Non généré"}
          </p>
        </div>
      </div>

      {Object.keys(byStep).length > 0 && (
        <div className="bg-[var(--surface)] border border-emerald-500/30 rounded-xl p-4">
          <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-2">Activité par étape</p>
          <div className="space-y-1.5">
            {[1, 2, 3, 4, 5].filter((s) => byStep[s]).map((s) => (
              <div key={s} className="flex items-center justify-between text-sm">
                <span className="text-zinc-300">Étape {s}</span>
                <span className="font-bold">{byStep[s].total}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
